import * as React from 'react';
import {Table,TableBody,TableCell,TableContainer,TableHead,TableRow,Paper, Button, Grid, 
  IconButton,TablePagination}  from "@mui/material"


import DeleteIcon from "@mui/icons-material/Delete"
import EditIcon from "@mui/icons-material/Edit"
import AddBoxIcon from '@mui/icons-material/AddBox';
import useStyles from '../theme/formCssStyles';
import { boolean } from 'yup';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';


export default function BasicTable(props) {
    // React.useState<readonly string[]>([]);
    const classes = useStyles();
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const rows = Array.isArray(props.rows) ? props.rows : [];
  const columns = Array.isArray(props.columns) ? props.columns : [];
    const [selected, setSelected] = React.useState(null);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [page, setPage] = React.useState(0);
    const dateTimeColumnWidthStyle = { width: 240, minWidth: 240, maxWidth: 240 };

    function isDateOrTimeColumn(col)
    {
      if(!col) return false;
      const dbName = (col.dbname || '').toLowerCase();
      const title = (col.title || '').toLowerCase();

      return (
        dbName.includes('date') ||
        dbName.includes('time') ||
        dbName === 'valid_from' ||
        dbName === 'valid_to' ||
        title.includes('date') ||
        title.includes('time')
      );
    }


    React.useEffect(()=>{
      if(props.alreadySelectedOwnRow != null)
      {
        setSelected(props.alreadySelectedOwnRow);
      }
    },[props.alreadySelectedOwnRow])

    const isSelected = (name) => 
    {
      if(selected === null)
        return false;
      if((selected !== null) || (selected !== undefined))
      {
        if(selected.id===name)
          return true;
        else
          return false;
      }
      
    };
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
    const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };
    React.useEffect(()=>{
     // if(selected !== null)
     // alert("Selected in table"+selected.name)
    },[selected]);
    function handleEdit(event,id){
      const selectedIndex = rows.find(x => x.id===id);//selected.indexOf(name);
      
      props.onEditClick(selectedIndex);
    }
    function handleDelete(event,id){
      const selectedIndex = rows.find(x => x.id===id);//selected.indexOf(name);
      
      props.onDeleteClick(selectedIndex.id);
    }
    const handleClick = (event, name) => {
      const selectedIndex = rows.find(x => x.id===name);//selected.indexOf(name);
      // let newSelected: readonly string[] = [];
  
     //  alert(selectedIndex+name+selected);
      // if (selectedIndex === -1) {
      //   newSelected = newSelected.concat(selected, name);
      // } else if (selectedIndex === 0) {
      //   newSelected = newSelected.concat(selected.slice(1));
      // } else if (selectedIndex === selected.length - 1) {
      //   newSelected = newSelected.concat(selected.slice(0, -1));
      // } else if (selectedIndex > 0) {
      //   newSelected = newSelected.concat(
      //     selected.slice(0, selectedIndex),
      //     selected.slice(selectedIndex + 1),
      //   );
      // }
      //alert("index:"+JSON.stringify(  selectedIndex)+"  row:"+props.rows[selectedIndex]);
      props.setSelectedRow(selectedIndex);
      props.setParentSelectedRow(selectedIndex);
      setSelected(selectedIndex);
      
    };
    function getColumnData(row,col)
    {
        const val = row[col.dbname];
        // treat coupon flags (stored as 0/1) as Yes/No
        if(col.dbname && (col.dbname.toLowerCase().includes('print_valid_coupon') || col.dbname.toLowerCase().includes('print_invalid_coupon')))
        {
          // some backends send number, some boolean
          if(val === 1 || val === true) return 'Yes';
          if(val === 0 || val === false) return 'No';
        }

        if(typeof(val) === "boolean")
        {
          return (val?"true":"false");
        }
        return val;
    }
    function getRowCellHtml(row,col,colIndex,totalColumns)
    {
      const dateTimeWidthStyle = isDateOrTimeColumn(col) ? dateTimeColumnWidthStyle : {};

        if(col.dbname ==='name')
      {
          return(    <TableCell style={{minWidth: 200}} component="th" scope="row"  id={row.id} align="center">
          {row.name}
          </TableCell>);
      }
      else if(col.dbname === "auth_key")
      {
        return(  <TableCell style={{...dateTimeWidthStyle, wordWrap:'break-word'}}  align="center"><div >{getColumnData(row,col)}</div></TableCell>);
      }
      else
      return(  <TableCell style={{...dateTimeWidthStyle, whiteSpace: 'nowrap'}} align="center"><div >{getColumnData(row,col)}</div></TableCell>);
    }
    return (
      // <Grid xs={12}  container direction='row'>
      // <Grid item xs={12}>
      <div style={{overflowX:'auto', width: '100%'}}>
        <TableContainer style={{overflowX:'auto', width: '100%'}}>
          <div>
            <Button
              variant="contained"
              color="primary"
              size="small"
              startIcon={<AddBoxIcon />}
              disabled={props.isAddDisabled}
              onClick={props.onAddClick}
              fullWidth={false}
              style={{ whiteSpace: 'nowrap' }}
            >
              Click to Add
            </Button>
          </div>
          <Table sx={{ minWidth: 200, width: '100%' }}  aria-label="simple table" size='small' >
            <TableHead>
              <TableRow  >
                <TableCell style={{ width: 32, maxWidth: 32, minWidth: 32, padding: '0 2px' }}> </TableCell>
                <TableCell style={{ width: 32, maxWidth: 32, minWidth: 32, padding: '0 2px' }}> </TableCell>
                {columns.map((col) => (
                  (() => {
                    const nameWidthStyle = col.dbname === 'name' ? { minWidth: 200 } : {};
                    const dateTimeWidthStyle = isDateOrTimeColumn(col) ? dateTimeColumnWidthStyle : {};
                    return (
                  col.dbname==="auth_key"?(
                  <TableCell style={{...nameWidthStyle, ...dateTimeWidthStyle, whiteSpace: 'normal'}}  key={col.title} align='center' >
                    <span style={{"fontWeight":"bolder", display: 'block', whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'anywhere', lineHeight: 1.2}}>
                    {col.title} </span></TableCell>):(
                  <TableCell style={{...nameWidthStyle, ...dateTimeWidthStyle, whiteSpace: 'normal'}}  key={col.title} align='center' >
                    <span style={{"fontWeight":"bold", display: 'block', whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'anywhere', lineHeight: 1.2}}>
                    {col.title} </span></TableCell>)
                    );
                  })()
                ))
                }
            </TableRow>
            </TableHead>
            <TableBody>
                
              {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                
                 
                <TableRow  
                onClick={(event) => handleClick(event, row.id)}
                  role="checkbox"
                  style={{ backgroundColor: isSelected(row.id) ? '#cfe8fc' : 'inherit' }}
                  aria-checked={isSelected(row.id)}
                          tabIndex={-1}
                          key={row.id}
                          selected={isSelected(row.id)}
                  
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell style={{ width: 32, maxWidth: 32, minWidth: 32, padding: '0 2px' }}>
                    <IconButton size="small" style={{ padding: 2 }} aria-label='delete' disabled={props.isDeleteDisabled} onClick={(event)=>(handleDelete(event,row.id))}><DeleteIcon style={{ fontSize: 18 }}/></IconButton>
                  </TableCell>
                  <TableCell style={{ width: 32, maxWidth: 32, minWidth: 32, padding: '0 2px' }}>
                    <IconButton size="small" style={{ padding: 2 }} aria-label='Edit' disabled={props.isEditDisabled} onClick={(event)=>handleEdit(event,row.id)}><EditIcon style={{ fontSize: 18 }}/></IconButton>
                  </TableCell>
                    {columns.map((col, colIndex) =>
                      getRowCellHtml(row,col,colIndex,columns.length)
                    
                  )}
                  {/* <TableCell component="th" scope="row" id={index}> */}
                
                  
                </TableRow>
              ))}
               {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: 33*emptyRows//(dense ? 33 : 53) * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
      //   </Grid>
      // </Grid>
    );
  }
  
